import React from 'react';
import { Box, Typography } from '@mui/material';
import { getRoleLabel } from 'Helpers';

export default function UserRoleBadge({ role }) {
    const roleColors = {
        admin: {
            bg: 'rgba(30, 124, 136, 0.1)',
            border: 'rgba(30, 124, 136, 0.2)',
            text: '#1E7C88'
        },
        supervisor: {
            bg: 'rgba(33, 150, 243, 0.1)',
            border: 'rgba(33, 150, 243, 0.2)',
            text: '#2196F3'
        },
        manager: {
            bg: 'rgba(156, 39, 176, 0.1)',
            border: 'rgba(156, 39, 176, 0.2)',
            text: '#9C27B0'
        },
        employee: {
            bg: 'rgba(76, 175, 80, 0.1)',
            border: 'rgba(76, 175, 80, 0.2)',
            text: '#4CAF50'
        },
        default: {
            bg: 'rgba(33, 150, 243, 0.1)',
            border: 'rgba(33, 150, 243, 0.2)',
            text: '#2196F3'
        }
    };

    const roleType = role?.role_type || 'default';
    const colors = roleColors[roleType] || roleColors.default;

    const RoleIcons = {
        admin: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        supervisor: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        manager: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 3L20 7.5V16.5L12 21L4 16.5V7.5L12 3Z"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        employee: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        default: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z"
                    stroke={colors.text}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    };

    return (
        <Box
            sx={{
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                background: colors.bg,
                padding: '4px 8px',
                borderRadius: '8px',
                border: `1px solid ${colors.border}`
            }}
        >
            {RoleIcons[roleType]}
            <Typography
                sx={{
                    fontSize: '0.7rem',
                    fontWeight: '500',
                    color: colors.text,
                    letterSpacing: '0.2px'
                }}
            >
                {getRoleLabel(roleType) || 'N/A'}
            </Typography>
        </Box>
    );
}
